import { useTranslation } from 'react-i18next';
import { useForm } from '@mantine/form';
import { FileInput, Grid, Button, Text } from '@mantine/core';
import { requiredFieldFormValidator } from '../../../utils/validators/formValidators';
import { useState } from 'react';
import { usePostHog } from 'posthog-js/react';
import { trackEvent } from '../../../utils/monitoring/posthog';
import { MonitoringEventTypes } from '../../../utils/monitoring/Monitoring_Events_Enum';

const UploadOrderEvidenceFile = ({
  onSubmit
}: {
  onSubmit: (values: any, formData: any) => Promise<boolean>;
}) => {
  const { t } = useTranslation(['FormValidator', 'FieldName', 'CommonButtons']);
  const posthog = usePostHog();
  const [loading, setLoading] = useState(false);
  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      files: []
    },
    validate: {
      files: (value) => {
        const requiredValidatorRes = requiredFieldFormValidator(value);
        if (requiredValidatorRes) return requiredValidatorRes;
      }
    }
  });
  type FormValues = typeof form.values;

  const onChange = (payload: File[] | null) => {
    if (!payload) return;
    form.setFieldValue('files', [...form.values.files, ...payload]);
  };

  const submit = async (values: FormValues) => {
    try {
      if (loading) return;
      setLoading(true);
      const formData = new FormData();

      values.files.forEach((file: File) => {
        formData.append('files', file);
      });

      const res = await onSubmit(values, formData);
      if (!res) throw Error('Algo salió mal');

      trackEvent(posthog, MonitoringEventTypes.ORDER_EVIDENCE_UPLOAD_SUCCESS, {
        fileCount: values.files.length
      });
      form.reset();
    } catch (error) {
      trackEvent(posthog, MonitoringEventTypes.ORDER_EVIDENCE_UPLOAD_FAIL, {
        fileCount: values.files.length
      });
      console.error('Error al cargar el archivo:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={form.onSubmit(submit)}>
      <Grid gutter={16}>
        <Grid.Col span={{ base: 12 }}>
          <Text size="sm" mb="xs">
            {t('OrdersPage:evidenceModal.evidenceHelpText')}
          </Text>
          <FileInput
            {...form.getInputProps('files')}
            multiple
            placeholder={t('FieldName:evidence')}
            label={t('FieldName:evidence')}
            onChange={onChange}
            accept=".png, .jpg, .jpeg"
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <Button type="submit" fullWidth loading={loading}>
            {t('CommonButtons:submit')}
          </Button>
        </Grid.Col>
      </Grid>
    </form>
  );
};

export default UploadOrderEvidenceFile;
